<template>
  <p class="py-2">
    Please complete your personal details
    <span class="font-semibold">using your most recent address.</span> If there is an identification
    error, try using a previous address that you may have more credit history or bills associated
    with.
  </p>
  <div class="flex flex-col md:flex-row md:justify-between py-2">
    <div class="flex flex-col md:w-5/12">
      <label for="first_name" class="block">
        First name <span class="text-brand-red">*</span>
      </label>
      <SingleLineInput
        id="first_name"
        type="text"
        placeholder="Enter first name"
        :value="firstName"
        @input="firstName = $event.target.value"
      ></SingleLineInput>
    </div>
    <div class="flex flex-col md:w-5/12">
      <label for="subject" class="block"> Last Name<span class="text-brand-red">*</span> </label>
      <SingleLineInput
        id="last_name"
        type="text"
        placeholder="Enter last name"
        :value="lastName"
        @input="lastName = $event.target.value"
      ></SingleLineInput>
    </div>
  </div>

  <div class="flex flex-col py-2">
    <label for="street_address" class="block">
      Address <span class="text-brand-red">*</span>
    </label>

    <AddressField
      :field="address"
      @update="updateAddress"
      @validated="validatedAddress"
      mode="edit"
    />
  </div>

  <div class="flex flex-col md:w-2/3 py-2">
    <label for="ssn" class="block">
      Social Security Number <span class="text-brand-red">*</span>
    </label>
    <SsnInput :ssn="ssn" @update="ssn = $event" />
  </div>

  <div v-if="errorMessage" class="flex md:w-1/2 md:px-5 py-3 mx-auto">
    <p class="text-brand-red text-sm text-center w-full">{{ errorMessage }}</p>
  </div>

  <div @click="goToQuestions" class="pb-8 flex w-full md:w-1/2 mx-auto mt-5">
    <PrimaryButton
      :disabled="!formValid || isUserLoading || isApplicationLoading"
      :is-loading="isUserLoading || isApplicationLoading"
      >Continue to security question</PrimaryButton
    >
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import hotkeys from "hotkeys-js"

import { USER_GET_EXPERIAN_QUESTIONS, APPLICATION_GET_EXPERIAN_QUESTIONS } from "@/store/types"

export default {
  data() {
    return {
      errorMessage: "",
      state: "",
      firstName: "",
      lastName: "",
      streetAddress: "",
      zip: "",
      city: "",
      ssn: "",
      failCount: 0,
      address: {}
    }
  },
  computed: {
    ...mapGetters(["isUserLoading", "getCurrentApplication", "isApplicationLoading"]),
    formValid() {
      const isValid = !!(
        this.firstName &&
        this.lastName &&
        this.streetAddress &&
        this.state &&
        this.zip &&
        this.city &&
        this.ssn
      )

      return isValid
    },
    currentRoute() {
      return this.$route.name
    }
  },
  props: {
    context: {
      type: String,
      default: "landlord"
    }
  },
  mounted() {
    const that = this

    hotkeys("ctrl+8", (event) => {
      // Prevent the default refresh event under WINDOWS system
      event.preventDefault()

      that.firstName = "Akkaya"
      that.lastName = "Jorge"
      that.streetAddress = "32 brook st"
      that.state = "NY"
      that.zip = "11772"
      that.city = "Patchogue"
      that.ssn = "666-72-0909"
    })
  },
  methods: {
    updateAddress(addr) {
      if (typeof addr === "string") {
        addr = JSON.parse(addr)
      }

      this.streetAddress = `${addr.street}${addr.unit ? ` ${addr.unit}` : ""}`
      this.state = addr.state
      this.zip = addr.zip
      this.city = addr.city
    },
    validatedAddress(addr) {
      this.streetAddress = `${addr.houseNumber} ${addr.street}`
      this.state = addr.stateCode
      this.zip = addr.postalCode.split("-")[0]
      this.city = addr.city
    },
    selectState(val) {
      this.state = val.value
    },
    async goToQuestions() {
      if (!this.formValid) return

      const { firstName, lastName, streetAddress, state, zip, city, ssn } = this

      try {
        if (this.context === "applicant") {
          const id = this.getCurrentApplication.id
          await this.$store.dispatch(APPLICATION_GET_EXPERIAN_QUESTIONS, {
            id,
            firstName,
            lastName,
            streetAddress,
            state,
            zip,
            city,
            ssn
          })
          this.$router.push({ name: "apply_verify_questions", params: { id } })
        } else {
          await this.$store.dispatch(USER_GET_EXPERIAN_QUESTIONS, {
            firstName,
            lastName,
            streetAddress,
            state,
            zip,
            city,
            ssn
          })
          this.$router.push({ name: "dashboard_verify_questions" })
        }
      } catch (err) {
        const error = err

        this.failCount = this.failCount + 1

        if (error.response.data.code === "max_attempts_reached" || this.failCount > 2) {
          if (this.context === "applicant") {
            this.$router.push({ name: "apply_verify_failure" })
          } else {
            if (this.currentRoute.includes("flow")) {
              this.$router.push({ name: "flow_listing_verify_failure" })
            } else {
              this.$router.push({ name: "dashboard_verify_failure" })
            }
          }
        } else {
          this.errorMessage = error.response.data.message || error.response.data.error
        }
      }
    }
  }
}
</script>
